module.exports = __webpack_public_path__ + "static/media/loader-new.413a329b.svg";